import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../../constant/Constant';
import { request } from '../ApiModule';

const BASE = 'modal/SUBJECT_DETAIL';
const INIT = BASE + PATH_DELIMITER + 'INIT';
const ACTION_SEARCH = BASE + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_ADD = BASE + PATH_DELIMITER + 'ACTION_ADD';
const ACTION_EDIT = BASE + PATH_DELIMITER + 'ACTION_EDIT';
const ACTION_REMOVE = BASE + PATH_DELIMITER + 'ACTION_REMOVE';
const HANDLE_DATA = BASE + PATH_DELIMITER + 'HANDLE_DATA';

export const actionInit = createAction(INIT);
export const actionSearch = createAction(ACTION_SEARCH);
export const actionAdd = createAction(ACTION_ADD);
export const actionEdit = createAction(ACTION_EDIT);
export const actionRemove = createAction(ACTION_REMOVE);

export function* subjectDetailSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_ADD, actionAddSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
    yield takeEvery(ACTION_REMOVE, actionRemoveSaga);
}

function* actionSearchSaga({ payload: { params } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/course/semesters/${params.semesterId}/universities/${params.lessonUniversityCd}/subjects/${params.subjectId}/classes/${params.classNo}/universitySubjects/${params.universitySubjectId}`,
    });
    if (result != undefined && result != null) {
        yield put({
            type: HANDLE_DATA,
            payload: {
                ...result.courseInfo,
                courseTimes: result.courseTimes,
            },
        });
    }
}

function* actionAddSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: `/api/course/semesters/${data.semesterId}/universities/${data.lessonUniversityCd}/subjects/${data.subjectId}/classes/${data.classNo}/universitySubjects/${data.universitySubjectId}`,
        data,
        callback,
    });
}

function* actionEditSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/course/semesters/${data.semesterId}/universities/${data.lessonUniversityCd}/subjects/${data.subjectId}/classes/${data.classNo}/universitySubjects/${data.universitySubjectId}`,
        data,
        callback,
    });
}

function* actionRemoveSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'delete',
        url: `/api/course/semesters/${data.semesterId}/universities/${data.lessonUniversityCd}/subjects/${data.subjectId}/classes/${data.classNo}/universitySubjects/${data.universitySubjectId}`,
        callback,
    });
}

const initialState = {
    subject: null,
};

const module = handleActions(
    {
        [INIT]: () => initialState,
        [HANDLE_DATA]: (state, { payload }) => ({ ...state, subject: payload }),
    },
    initialState,
);

export default module;
